import React, { useState, useEffect } from 'react';
import { useParams,useHistory } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Header from '../../layout/Header';
import Menu from '../../layout/Menu';
import Copyright from '../../layout/Copyright';
import { useStyles,drawerWidth } from "../../layout/styles";
import CustomPaginationActionsTable from "../../table/Table"
import Filter from "../../filter/Filter"
import Form from "../../form/Form"
import toast from 'toasted-notes'
import CheckIcon from '@material-ui/icons/Check';
import 'toasted-notes/src/styles.css';
import Modal from '@material-ui/core/Modal';
import {rentallensService as service, rentalfamilyService , typeLensService, markService, manufactureService, serieService, diameterService, focalService, tstopService, minfocusService, lengthService, weightService} from "../../../services"


  const initFamilyElement = {
     family: {id: -1, name: ""},
  };

  const initSerieElement = {
       nseries:"",
       id:""
    };


  const initFilter =  {
      family: null,
      attrtype : "",
      attrmark: "",
      serie: "",
      manufacture: null,
      attrfocal: null,
      attrtstop: null,
      attrweight: null,
      attrfrontDimeter: null,
      attrminFocus: null,
      attrlength: null,
      coberture: null,
      mount: null,
      year: null,
};


const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  tablecontainer: {
    boxShadow: "none",
  },
  bodymodal: {
    margin: "auto",
    width: "500px",
    maxWidth: "calc(100vh - 40px)",
    background: "white",
    padding: "5em",
    marginTop: "100px",
    textAlign: "center"
  }
});


export default function FormFamilyLensRental() {
  const classes2 = useStyles2();
  const history = useHistory();
  let { id } = useParams();
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [objectfamilyform,setObjectfamilyform] = React.useState({...initFamilyElement});


  const [objectserieform,setObjectserieform] = React.useState({...initSerieElement});
  const [titleWindow, setTitleWindow] = React.useState(id && id > 0? 'Editar lentes de familia':'');
  const [idRow, setIdrow] = React.useState(id?id:-1);



  const [filter, setFilter] = React.useState({...initFilter});
  const fieldstable = ["lens.focal.name","lens.serie.name","nseries"];
  const headersTable =  ["Focal","Serie", "Nº de series"];
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows,setRows] = React.useState([{}]);
  const [rowsTotal,setRowsTotal] = React.useState(0);
  const [selectLens,setSelectLens] = React.useState({});
  const [openSerie, setOpenSerie] = React.useState(false);


  const [filterLens, setFilterLens] = React.useState({...initFilter});
  const fieldstableLens = ["focal.name","serie.name"];
  const headersTableLens =  ["Focal","Serie"];
  const [pageLens, setPageLens] = React.useState(0);
  const [rowsPerPageLens, setRowsPerPageLens] = React.useState(10);
  const [rowsLens,setRowsLens] = React.useState([{}]);
  const [rowsTotalLens,setRowsTotalLens] = React.useState(0);

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };


  const [estructurefamilyform,setEstructurefamilyform] = React.useState([
        {
         type:"autocomplete",
         name: "family.id",
         label: "Familia",
         service: rentalfamilyService.combo,
         col: 12
        }
    ]);

    const [estructurenserie,setEstructurenserie] = React.useState([
          {
           type:"input",
           name: "nseries",
           label: "Nº Serie",
           col: 12
          }
      ]);

    useEffect(() => {
        if(idRow && idRow > 0){

          //searchOne();
        };

    }, []);


  const isValid = function(object){
      if(!object['family']){
        toast.notify("Debe indicar una familia", {position:'top', duration: 10000})
        return false;
      }

      return true;
  }

  const cleanElementsBeforeSave = function(object){
    let newObj = JSON.parse(JSON.stringify(object));
    return newObj;
  }

  const changePageTable = (page,size) => {
    search(page,size,idRow);
  };



  const cleanFilter = (filter) => {
    console.log(filter);
    setFilter(filter);
    search(0,rowsPerPage,idRow);

  }

  const searchFilter = (filter) => {
    console.log(filter);
    setFilter(filter);
    search(0,rowsPerPage,idRow);
  }




  const createEstructureFilter =  [
       {
         type:"autocomplete",
         name: "attrtype",
         label: "Tipo",
         service: typeLensService.combo,
         col: 4
        },
        {
          type:"autocomplete",
          name: "attrmark",
          label: "Familia",
          service: markService.combo,
          col: 4
         },
         {
           type:"autocomplete",
           name: "manufacture",
           label: "Fabricante",
           service: manufactureService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "serie",
           label: "Serie",
           service: serieService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrfocal",
           label: "Focal",
           service: focalService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrtstop",
           label: "T.Stop",
           service: tstopService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrweight",
           label: "Peso",
           service: weightService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrfrontDimeter",
           label: "Diam. Frontal",
           service: diameterService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrminFocus",
           label: "Min. Foc.",
           service: minfocusService.combo,
           col: 4
          },
         {
           type:"autocomplete",
           name: "attrlength",
           label: "Tamaño",
           service: lengthService.combo,
           col: 4
          },
         {
           type:"input",
           name: "coberture",
           label: "Cobertura",
           col: 4
          },
         {
           type:"input",
           name: "mount",
           label: "Montura",
           col: 4
          },
         {
           type:"input",
           name: "year",
           label: "Año",
           col: 4
          },
    ];

    const createEstructureFilterLens =  [
         {
           type:"autocomplete",
           name: "attrtype",
           label: "Tipo",
           service: typeLensService.combo,
           col: 4
          },
          {
            type:"autocomplete",
            name: "attrmark",
            label: "Familia",
            service: markService.combo,
            col: 4
           },
           {
             type:"autocomplete",
             name: "manufacture",
             label: "Fabricante",
             service: manufactureService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "serie",
             label: "Serie",
             service: serieService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrfocal",
             label: "Focal",
             service: focalService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrtstop",
             label: "T.Stop",
             service: tstopService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrweight",
             label: "Peso",
             service: weightService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrfrontDimeter",
             label: "Diam. Frontal",
             service: diameterService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrminFocus",
             label: "Min. Foc.",
             service: minfocusService.combo,
             col: 4
            },
           {
             type:"autocomplete",
             name: "attrlength",
             label: "Tamaño",
             service: lengthService.combo,
             col: 4
            },
           {
             type:"input",
             name: "coberture",
             label: "Cobertura",
             col: 4
            },
           {
             type:"input",
             name: "mount",
             label: "Montura",
             col: 4
            },
           {
             type:"input",
             name: "year",
             label: "Año",
             col: 4
            },
      ];


    const deleteHandler = (id) => {
      service.remove(id, (data, error) => {
          if(data){
            console.log(data);
              search(page,rowsPerPage,idRow);
              searchLens(pageLens,rowsPerPageLens,idRow);
          }
      });
    }

    const selectLensHandler = (id) => {
          var lf = {
            family:{
              id:objectfamilyform["family"]["id"]
            },
            lens:{
              id:id
            },
            nseries:""
          };

          service.create(lf, (data, error) => {
              if(data){
                search(page,rowsPerPage,idRow);
                searchLens(pageLens,rowsPerPageLens,idRow);
              }
          });
    }

    const search = (page,size,id) => {
      setPage(page);
      setRowsPerPage(size);
      if (objectfamilyform != null && objectfamilyform["family"]['id'] != null && objectfamilyform["family"]['id'] > 0){
        service.searchfamily(page,size,objectfamilyform["family"]['id'],filter, (data, error) => {
            if(data){
              console.log(data);
              setRows(data.data);
              setRowsTotal(data.total);
            } else {
              setRows([{}]);
              setRowsTotal(0);
            }
        });
      } else if(id > 0){
        service.searchfamily(page,size,id,filter, (data, error) => {
            if(data){
              console.log(data);
              setRows(data.data);
              setRowsTotal(data.total);
            } else {
              setRows([{}]);
              setRowsTotal(0);
            }
        });
      }

    }
    const changeFamily = (object) => {
         if(isValid(object)) {
           //var objToSave = cleanElementsBeforeSave(object);
           setObjectfamilyform(object);
           console.log(filter);
           setFilter(filter);
           search(0,rowsPerPage,idRow);
           searchLens(0,rowsPerPageLens,idRow);
         }

    }


    const changePageTableLens = (page,size) => {
      searchLens(page,size,idRow);
    };



    const cleanFilterLens = (filter) => {
      console.log(filter);
      setFilterLens(filter);
      searchLens(0,rowsPerPage,idRow);

    }

    const searchFilterLens = (filter) => {
      console.log(filter);
      setFilterLens(filter);
      searchLens(0,rowsPerPage,idRow);
    }


    const searchLens = (page,size,id) => {
      setPageLens(page);
      setRowsPerPageLens(size);
      if (objectfamilyform != null && objectfamilyform["family"] != null && objectfamilyform["family"]['id'] != null && objectfamilyform["family"]['id'] > 0){
        service.searchNotfamily(page,size,objectfamilyform["family"]['id'],filterLens, (data, error) => {
            if(data){
              console.log(data);
              setRowsLens(data.data);
              setRowsTotalLens(data.total);
            } else {
              setRowsLens([{}]);
              setRowsTotalLens(0);
            }
        });
      } else if(id > 0){
        service.searchNotfamily(page,size,id,filterLens, (data, error) => {
            if(data){
              console.log(data);
              setRowsLens(data.data);
              setRowsTotalLens(data.total);
            } else {
              setRowsLens([{}]);
              setRowsTotalLens(0);
            }
        });
      }

    }

    const eventSelect = (id) => {
        console.log("Selecciona el id " + id);

        for (var row of rows) {
          if (row["id"] == id){
            setObjectserieform(currentObjectserieform => ({...currentObjectserieform, ["id"]: id }))
            setObjectserieform(currentObjectserieform => ({...currentObjectserieform, ["nseries"]: row["nseries"] }))
            setOpenSerie(true);
            break;
          }
        }
    }

    const handleCloseSerie = () => {
       setOpenSerie(false);
     };

     const cancelSerie = () => {
        setOpenSerie(false);
     }


   const saveSerie = (object) => {
        setOpenSerie(false);
        service.edit(object['id'],object, (data, error) => {
            if(data){
                search(page,rowsPerPage,idRow);
            }
        });
   }

   useEffect(() => {
       if(idRow && idRow > 0){
         searchFamily(idRow)
         search(0,rowsPerPage,idRow);
         searchLens(0,rowsPerPageLens,idRow);
       };

   }, []);

   const searchFamily = (id) => {
     rentalfamilyService.one(id,(data, error) => {
         if(data){
           let objectedit = JSON.parse(JSON.stringify(objectfamilyform));
           objectedit["family"] = data.data
           setIdrow(data.data.id);
           setObjectfamilyform(objectedit)
         }
     })
   }



  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header title={titleWindow} classes={classes} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}/>
      <Menu classes={classes} open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose}/>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3} className={classes.bodycontainer}>
              <Grid item sm={12} xs={12} style={{textAlign:'right', marginBottom: '10px'}}>
                  <Form objectform={objectfamilyform} fields={estructurefamilyform} searchFilter={changeFamily} isHiddenCancel={true} labelsave="Seleccionar familia"/>
              </Grid>
              <Grid item sm={6} xs={6} style={{textAlign:'right', marginBottom: '10px'}}>
                <Grid container>
                    <h2>Lentes seleccionadas</h2>
                </Grid>
                <Grid container style={{marginBottom: '50px'}}>
                  <Filter cleanFilter={cleanFilter} searchFilter={searchFilter} filter={filter}  estructure={createEstructureFilter} hiddenButton={true} />
                </Grid>
                <Grid container spacing={3} className={classes.bodycontainer}>
                  <CustomPaginationActionsTable rows={rows} fields={fieldstable} fieldId={"id"} rowsPerPage={10} rowsTotal={rowsTotal} changePage={changePageTable} headers={headersTable} page={page}  deleteaction={true} deleteactionHandler={deleteHandler} selectHandler={eventSelect}/>
                </Grid>
              </Grid>
              <Grid item sm={6} xs={6} style={{textAlign:'right', marginBottom: '10px'}}>
                    <Grid container>
                        <h2>Lentes no seleccionadas</h2>
                    </Grid>
                    <Grid container style={{marginBottom: '50px'}}>
                      <Filter cleanFilter={cleanFilter} searchFilter={searchFilterLens} filter={filterLens}  estructure={createEstructureFilterLens} hiddenButton={true}/>
                    </Grid>
                    <Grid container spacing={3} className={classes.bodycontainer}>
                      <CustomPaginationActionsTable rows={rowsLens} fields={fieldstableLens} fieldId={"id"} rowsPerPage={10} rowsTotal={rowsTotalLens} changePage={changePageTableLens} headers={headersTableLens} page={pageLens}  deleteaction={true} colorIconDeleteAction={"green"} deleteactionHandler={selectLensHandler} iconDeleteAction={<CheckIcon />} actionQuestion={"¿Deseas añadir esta lente?"}/>
                    </Grid>
              </Grid>
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
      <Modal
          open={openSerie}
          onClose={handleCloseSerie}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description">
          <div className={classes2.bodymodal}>
            <div style={{marginBottom:'30px'}}>
                <Form objectform={objectserieform} fields={estructurenserie} cleanFilter={cancelSerie} searchFilter={saveSerie} labelsave="Guardar nº serie"/>
            </div>
        </div>
        </Modal>
    </div>
  );
}
